import React, { HTMLProps } from 'react';

import Props from './SocialButtonsInterface';
import { AppleIcon, SocialButton } from './styles';

export function AppleForm({
  xsrft,
  action,
  children,
  optIn,
  redirectUrl,
  onClick,
  onSubmit,
  className,
  turnstileToken,
  target = '_self',
}: Props) {
  const url = action === 'join' ? '/join' : '/log_in';

  const formProps: HTMLProps<HTMLFormElement> = {
    id: 'apple_form',
    method: 'POST',
    action: url,
    noValidate: true,
    onSubmit: onSubmit,
    target: target,
  };

  if (target === '_blank') {
    formProps.rel = 'opener';
  }

  return (
    <form {...formProps}>
      <input type="hidden" name="service" value="apple" />
      <input type="hidden" name="action" value={action} />
      <input type="hidden" name="token" value={xsrft} />
      {turnstileToken !== null && (
        <input type="hidden" name="cf-turnstile-response" value={`${turnstileToken}`} />
      )}
      {redirectUrl && <input type="hidden" name="redirect" value={redirectUrl} />}
      {optIn !== null && <input type="hidden" name="marketing_opt_in" value={`${optIn}`} />}
      <SocialButton
        className={className}
        icon={<AppleIcon />}
        format="secondary"
        onClick={() => onClick?.()}
      >
        {children}
      </SocialButton>
    </form>
  );
}
